let url = window.location.href
let apiUrl = 'http://jdashley.me/apis/'

if (url.includes('localhost')) {
    apiUrl = 'http://localhost/jdashley-professional-site-backend/'
}

let axiosConfig = {
    'Content-Type': 'application/json;charset=UTF-8',
    'Access-Control-Allow-Origin': '*'
}

export { apiUrl, axiosConfig }